import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import "./footer.scss";

const FooterOfRent = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            R_kreysayara,
            R_totalID,
            R_waslKrdn,
            R_waslKrdnID,
            R_total,
            R_kreykrekar,
            R_isChecked,
            R_rasidWakildolar,
            R_rasidWakildinar,
            R_WakilQard_isChecked,
            R_dashkan,
            R_kamkrdnawayNrx$,
            R_rasidWakildolarNew,
            R_rasidWakildinarNew,
            R_paraDanID,
            R_paraDan$,
            R_kamkrdnawayNrxID,
            R_dashkanID,
            R_joripara,
            R_frosth,
            FIB, cash
          } = value;
          return (
            <>
              <html dir="rtl">
                <div className="row fk">
                  <div className="col-2"></div>
                  <div className="col-6">
                    {R_WakilQard_isChecked == true &&
                    R_frosth == "فرۆشتنی وەکیل" ? (
                      <>
                        <table className="responstable">
                          <tr>
                            <th scope="row" style={{ fontSize: "25px" }}>
                              قەرزی کۆن
                            </th>
                            <td
                              className="text-danger1"
                              style={{
                                fontSize: "25px",
                                backgroundColor: "#80bfea"
                              }}
                            >
                              <NumberFormat
                                value={
                                  R_joripara == "دۆلار"
                                    ? Number(R_rasidWakildinarNew)
                                    : Number(R_rasidWakildolarNew)
                                }
                                thousandSeparator={true}
                                displayType="text"
                                prefix={R_joripara == "دۆلار" ? "IQD" : "$"}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" style={{ fontSize: "25px" }}>
                              قەرزی کۆن
                            </th>
                            <td style={{ fontSize: "25px" }}>
                              <NumberFormat
                                value={
                                  R_joripara == "دۆلار"
                                    ? Number(R_rasidWakildolar).toFixed(2)
                                    : Number(R_rasidWakildinar).toFixed(2)
                                }
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={R_joripara == "دۆلار" ? "$" : "IQD"}
                              />
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" style={{ fontSize: "25px" }}>
                              قەرزی نوێ
                            </th>
                            <td style={{ fontSize: "25px" }}>
                              <NumberFormat
                                value={
                                  R_joripara == "دۆلار"
                                    ? Number.isInteger(
                                        Number(R_rasidWakildolarNew)
                                      )
                                      ? Number(R_rasidWakildolarNew)
                                      : Number(R_rasidWakildolarNew).toFixed(2)
                                    : Number.isInteger(
                                        Number(R_rasidWakildinarNew)
                                      )
                                    ? Number(R_rasidWakildinarNew)
                                    : Number(R_rasidWakildinarNew).toFixed(2)
                                }
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={R_joripara == "دۆلار" ? "$" : "IQD"}
                              />
                            </td>
                          </tr>
                        </table>
                      </>
                    ) : null}
                  </div>
                  <div className="col-4">
                    <table className="responstable">
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          کۆی گشتی
                        </th>
                        <td
                          className="text-danger1"
                          style={{
                            fontSize: "25px",
                            backgroundColor: "#80bfea"
                          }}
                        >
                          <NumberFormat
                            value={R_joripara == "دۆلار" ? R_total : R_totalID}
                            thousandSeparator={true}
                            displayType="text"
                            prefix={R_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          کەمکردنەوە
                        </th>
                        <td style={{ fontSize: "25px" }}>
                          <NumberFormat
                            value={
                              R_joripara == "دۆلار" ? R_dashkan : R_dashkanID
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={R_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          جۆری پارەدان
                        </th>
                        <td style={{ fontSize: "25px" }}>
                          {FIB ? "FIB" : cash ? "کاش" : "قەرز"}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          پارەی دراو
                        </th>
                        <td style={{ fontSize: "25px" }}>
                          <NumberFormat
                            value={
                              R_joripara == "دۆلار" ? R_paraDan$ : R_paraDanID
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={R_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          پارەی ماوە
                        </th>
                        <td
                          className="text-danger1"
                          style={{
                            fontSize: "25px",
                            backgroundColor: "#80bfea"
                          }}
                        >
                          <NumberFormat
                            value={
                              R_joripara == "دۆلار"
                                ? R_paraDan$ != 0 && R_paraDan$ != ""
                                  ? R_waslKrdn()
                                  : R_kamkrdnawayNrx$()
                                : R_paraDanID != 0 && R_paraDanID != ""
                                ? R_waslKrdnID()
                                : R_kamkrdnawayNrxID()
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            dir="ltr"
                            prefix={R_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </html>
              {/* {R_joripara == "دۆلار" ? (
               
                    <div className="col-5 tc">
                      <div className="row">
                        <div className="col-3 mb3">
                          {R_isChecked == true ? (
                            <>
                              <h3>
                                <NumberFormat
                                  value={R_kreysayara}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={R_joripara == "دۆلار" ? "$" : "ID"}
                                />
                              </h3>
                              <hr />
                              <h3>
                                <NumberFormat
                                  value={R_kreykrekar}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={R_joripara == "دۆلار" ? "$" : "ID"}
                                />
                              </h3>
                              <hr />
                            </>
                          ) : null}
                          
                  </div>
                </>
              ) : (
                ""
              )}
            
                    <div className="col-5">
                      <div className="row">
                        <div className="col-3 mb3 tc">
                          {R_isChecked == true ? (
                            <>
                              <h3>
                                <NumberFormat
                                  value={R_kreysayara}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"ID"}
                                />
                              </h3>
                              <hr />
                              <h3>
                                <NumberFormat
                                  value={R_kreykrekar}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"ID"}
                                />
                              </h3>
                              <hr />
                            </>
                          ) : null}
                         
                              <h3>
                                <NumberFormat
                                  value={
                                    Number.isInteger(
                                      Number(R_rasidWakildinarNew)
                                    )
                                      ? Number(R_rasidWakildinarNew)
                                      : Number(R_rasidWakildinarNew).toFixed(2)
                                  }
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"ID"}
                                />
                              </h3>
                              <hr />
                            </>
                          ) : null}
                        </div>
                        <div className="col-9 text-right mb3">
                          {R_isChecked == true ? (
                            <>
                              <h3 className="ml5">:کرێ سەیارە</h3>
                              <hr />
                              <h3 className="ml5">:کرێ کرێکار</h3>
                              <hr />
                            </>
                          ) : null}
                          {R_WakilQard_isChecked == true &&
                          R_frosth == "فرۆشتنی وەکیل" ? (
                            <>
                              <h3 className="ml5">:$ قەرزی کۆن</h3>
                              <hr />
                              <h3 className="ml5">:ID قەرزی کۆن</h3>
                              <hr />
                              <h3 className="ml5">:ID قەرزی نوێ</h3>
                              <hr />
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )} */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfRent;
